import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const domains = [
  {
    icon: 'ri-bar-chart-2-line',
    title: 'Conseil en gestion',
    description: 'Structuration et organisation de l\'activité pour gagner en efficacité.',
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Stratégie d\'entreprise',
    description: 'Aide à la prise de décision et au développement à long terme.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Optimisation des activités',
    description: 'Analyse et amélioration des processus et de la performance globale.',
  },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />

      {/* Page Hero */}
      <section className="pt-36 pb-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <span className="text-xs font-semibold uppercase tracking-widest text-navy-700 mb-4 block">
            À propos
          </span>
          <h1 className="text-5xl font-bold text-navy-800 leading-tight max-w-2xl">
            À propos de KRUTAK
          </h1>
        </div>
      </section>

      {/* Présentation */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div>
              <h2 className="text-3xl font-bold text-navy-800 mb-8 leading-tight">
                Une expertise indépendante au service des entrepreneurs
              </h2>
              <div className="space-y-5 text-gray-600 text-[16px] leading-relaxed">
                <p>
                  <strong className="text-navy-800">KRUTAK</strong> est une activité indépendante de conseil basée à Lille. Spécialisée dans l'accompagnement des entrepreneurs et des entreprises, elle intervient pour structurer, optimiser et développer les activités.
                </p>
                <p>
                  L'entreprise est dirigée par <strong className="text-navy-800">Maria Ruta Krutak</strong>, spécialisée dans le conseil en gestion et développement d'activité. Son approche rigoureuse et personnalisée permet d'apporter des solutions concrètes adaptées à chaque situation.
                </p>
                <p>
                  Qu'il s'agisse de structurer une nouvelle activité, d'améliorer les performances ou de prendre des décisions stratégiques, KRUTAK est un partenaire de confiance pour les entrepreneurs à toutes les étapes de leur développement.
                </p>
              </div>

              <Link
                to="/contact"
                className="whitespace-nowrap cursor-pointer mt-10 inline-flex items-center gap-2 bg-navy-800 text-white text-[15px] font-medium px-7 py-3.5 rounded-lg hover:bg-navy-700 transition-colors duration-200"
              >
                Nous contacter
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </Link>
            </div>

            <div className="space-y-6">
              {/* Carte identité */}
              <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100">
                <h3 className="text-xs font-semibold uppercase tracking-widest text-navy-700 mb-6">
                  Informations entreprise
                </h3>
                <ul className="space-y-4">
                  {[
                    { icon: 'ri-building-2-line', label: 'Entreprise', value: 'KRUTAK' },
                    { icon: 'ri-user-line', label: 'Dirigeante', value: 'Maria Ruta Krutak' },
                    { icon: 'ri-id-card-line', label: 'Statut', value: 'Entrepreneur individuel' },
                    { icon: 'ri-file-list-3-line', label: 'SIRET', value: '999 389 893 00010' },
                    { icon: 'ri-map-pin-2-line', label: 'Adresse', value: '23 Rue Nationale, 59800 Lille' },
                    { icon: 'ri-briefcase-line', label: 'Activité', value: '70.22Z – Conseil en affaires' },
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-4">
                      <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-navy-100 mt-0.5 shrink-0">
                        <i className={`${item.icon} text-navy-700 text-sm`} />
                      </span>
                      <div>
                        <p className="text-xs text-gray-400 font-medium mb-0.5">{item.label}</p>
                        <p className="text-navy-800 font-medium text-[14px]">{item.value}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Photo */}
              <div className="rounded-2xl overflow-hidden h-64">
                <img
                  src="https://public.readdy.ai/ai/img_res/8ac0ad859a54652d5bc8f797b9d05457.jpg"
                  alt="Maria Ruta Krutak – KRUTAK"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Domaines d'intervention */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-14">
            <span className="text-xs font-semibold uppercase tracking-widest text-navy-700 mb-3 block">
              Expertise
            </span>
            <h2 className="text-3xl font-bold text-navy-800">
              Domaines d'intervention
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {domains.map((domain, i) => (
              <div
                key={i}
                className="bg-white rounded-xl p-8 border border-gray-100 hover:border-navy-200 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-navy-50 mb-5">
                  <i className={`${domain.icon} text-xl text-navy-700`} />
                </div>
                <h3 className="text-[17px] font-bold text-navy-800 mb-3">
                  {domain.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  {domain.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Valeurs */}
      <section className="py-20 bg-navy-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4 block">
                Nos valeurs
              </span>
              <h2 className="text-3xl font-bold text-white mb-6">
                Un engagement total envers vos résultats
              </h2>
              <p className="text-gray-300 text-[16px] leading-relaxed">
                Chaque mission est abordée avec rigueur, transparence et engagement. L'objectif est toujours le même : apporter des solutions concrètes, mesurables et durables.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-6">
              {[
                { icon: 'ri-focus-3-line', label: 'Rigueur' },
                { icon: 'ri-eye-line', label: 'Transparence' },
                { icon: 'ri-heart-line', label: 'Engagement' },
                { icon: 'ri-lightbulb-line', label: 'Pragmatisme' },
              ].map((val, i) => (
                <div key={i} className="bg-navy-700/50 rounded-xl p-6 border border-navy-600">
                  <div className="w-10 h-10 flex items-center justify-center mb-3">
                    <i className={`${val.icon} text-2xl text-white`} />
                  </div>
                  <p className="text-white font-semibold text-[15px]">{val.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
